import type { OrdersTab } from "~/components/services/orders/ordersTab";

export const orderQueries = {
  pending: (args: { teamId?: string | number | null; actions?: string[] }) =>
    [
      "orders",
      "pending",
      {
        teamId: args.teamId ?? null,
        actions: (args.actions ?? []).slice().sort(),
      },
    ] as const,
  // Past Orders; `lists(teamId)` matches every tab and page of a team's.
  lists: (teamId: number | undefined) =>
    ["orders", "list", { teamId: teamId ?? null }] as const,
  list: (args: {
    teamId: number | undefined;
    type: OrdersTab;
    page: number;
    size: number;
  }) =>
    [
      "orders",
      "list",
      {
        teamId: args.teamId ?? null,
        type: args.type,
        page: args.page,
        size: args.size,
      },
    ] as const,
  latest: (teamId: number | undefined) =>
    ["orders", "latest", { teamId: teamId ?? null }] as const,
};
